import React from 'react';
import { useFormContext } from 'react-hook-form';
import { MarketInvestmentsAccordion } from './MarketInvestmentsAccordion';
import { OtherAssetsAccordion } from './OtherAssetsAccordion';
import { ObligationsAccordion } from './ObligationsAccordion';
import { IncomesAccordion } from './IncomesAccordion';
import { ClientAccordion } from './ClientAccordion';
import { ControlledAccordion } from '../../common/ControlledAccordion';
import { AssetAdvisoryFormValues } from './useAssetAdvisoryForm';

export function AdvisorySection() {
  /**
 * Extends the initial interface to include the session number.
 * The session number is not part of the original form interface
 * because it is not required from the user input,
 * but it is included in the data received from the backend.
 */
  const { formState: { defaultValues } } = useFormContext<
  AssetAdvisoryFormValues & { session: number }
  >();
  const storageSession = defaultValues?.session
    ? { sessionId: defaultValues?.session, prefix: 'asset_advisory_form' } : undefined;
  return (
    <section className="d-flex flex-column gap-6">
      <div className="fw-bold fs-lg text-primary text-center mx-auto mt-6">
        <img className="img-fluid mb-3" src="/static/img/illustrations/checklist-woman.svg" width={100} height={100} alt="Mujer checkeando items de una lista" />
        <p className="mb-0">Preguntas clave</p>
      </div>
      <ControlledAccordion defaultActiveKey="0" storageSession={storageSession}>
        <ClientAccordion />
        <MarketInvestmentsAccordion />
        <OtherAssetsAccordion />
        <ObligationsAccordion />
        <IncomesAccordion />
      </ControlledAccordion>
    </section>
  );
}
